export const PERMISSIONS = {
    ANALYTICS: 'analytics',
    SCHEDULER: 'scheduler',
    INSTAGRAM_DM: 'instagram_dm',
    MESSENGER_DM: 'messenger_dm',
    ADS: 'ads',
    SCHEDULER_MENTIONS: 'scheduler_mentions'
} as const;
